module.exports = __webpack_public_path__ + "img/1services.73ebeaed.svg";